
//componentes
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
//tipos
import { Pesaje } from "@/typings/store/plugins/easyFirestore/pesajes";
import {
  Archivos,
  Archivo,
} from "@/typings/store/plugins/easyFirestore/archivos";

@Component
export default class GaleriaImagenes extends Vue {
  @Prop() readonly pesaje!: Pesaje;
  @Prop() readonly archivos!: Archivos;

  fotoSeleccionada: string | null = null;

  get arrayArchivos(): Array<Archivo> {
    return Object.values(this.archivos);
  }

  get fotos(): Array<string> {
    return this.pesaje.fotos.map((foto) => {
      return foto.url ?? "";
    });
  }

  @Emit("click:cerrar")
  onClickCerrar(): void {
    return;
  }

  seleccionarFoto(foto: string): void {
    this.fotoSeleccionada = foto;
  }
}
